import React, { useEffect, useState } from "react";
import { visibleAwards } from "../data/awards";

/* AwardBadges
   -----------
   Award logos for three places: pinned to the hero photo ("hero"), in the
   footer brand block ("footer") and in the enrol page trust strip ("enrol").
   Renders nothing until an award's embargo date (see data/awards.js), so it
   can ship ahead of the announcement. The preview override is applied after
   mount so the first client render matches the prerendered HTML.
*/
const useAwards = () => {
  const [preview, setPreview] = useState(false);
  useEffect(() => {
    try {
      setPreview(new URLSearchParams(window.location.search).get("awards") === "preview");
    } catch (e) {
      /* no window (prerender) */
    }
  }, []);
  return visibleAwards({ preview });
};

const Badge = ({ award, className }) => (
  <picture>
    <source srcSet={`${award.src}.webp`} type="image/webp" />
    <img
      src={`${award.src}.png`}
      alt={award.alt}
      width={award.width}
      height={award.height}
      loading="lazy"
      decoding="async"
      className={className}
    />
  </picture>
);

const AwardBadges = ({ variant = "footer" }) => {
  const awards = useAwards();
  if (!awards.length) return null;

  if (variant === "hero") {
    return (
      <div className="bs-awards bs-awards--hero" data-testid="awards-hero">
        {awards.map((a) => (
          <Badge key={a.id} award={a} className="bs-awards__img" />
        ))}
      </div>
    );
  }

  if (variant === "enrol") {
    return (
      <div className="bs-awards bs-awards--enrol" data-testid="awards-enrol">
        {awards.map((a) => (
          <div className="bs-awards__item" key={a.id}>
            <Badge award={a} className="bs-awards__img" />
            <div className="bs-awards__text">
              <strong>{a.label}</strong>
              <span>{a.detail}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="bs-awards bs-awards--footer" data-testid="awards-footer">
      {awards.map((a) => (
        <Badge key={a.id} award={a} className="bs-awards__img" />
      ))}
    </div>
  );
};

export default AwardBadges;
